import classNames from 'classnames'
import { FC, ReactNode } from 'react'

import styles from './alert.module.css'
import { Icons } from '../icon/constants'
import Icon from '../icon/Icon'
import { typographyColor, typographyType } from '../typography/constants'
import Typography from '../typography/Typography'


interface IAlertProps {
    text: string | ReactNode
    onClose: () => void,
    className?: string
}

const Alert: FC<IAlertProps> = ({
    text,
    onClose,
    className,
}) => {
    return (
        <div className={ classNames(styles.card, className) } role="alert">
            <Icon
                icon={ Icons.warningCircle }
                className={ styles.infoIcon }
            />
            <Typography
                color={ typographyColor.secondary }
                type={ typographyType.body5 }
            >
                { text }
            </Typography>
            
            <button onClick={ onClose } className={ styles.closeButton }>
                <Icon icon={ Icons.x }/>
            </button>
        </div>
    )
}

export default Alert
